/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Charter/{charter-id}/CrewBriefing/Pdf
 */
export interface PdfRequestBuilder extends BaseRequestBuilder<PdfRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ArrayBuffer>}
     */
     get(requestConfiguration?: RequestConfiguration<PdfRequestBuilderGetQueryParameters> | undefined) : Promise<ArrayBuffer | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<PdfRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface PdfRequestBuilderGetQueryParameters {
    templateFileName?: string;
}
/**
 * Uri template for the request builder.
 */
export const PdfRequestBuilderUriTemplate = "{+baseurl}/Charter/{charter%2Did}/CrewBriefing/Pdf?templateFileName={templateFileName}";
/**
 * Metadata for all the requests in the request builder.
 */
export const PdfRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PdfRequestBuilderUriTemplate,
        responseBodyContentType: "application/pdf",
        adapterMethodName: "sendPrimitive",
        responseBodyFactory:  "ArrayBuffer",
    },
};
/* tslint:enable */
/* eslint-enable */
